import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { EmailTemplate, ToDoTemplate } from "../../bpe/bpe.service";
import { ModalComponent } from "../modal.component";

@Component({
    template: `
        @if (isInit) {
            <div class="s25-ng">
                <s25-modal-header [data]="data"></s25-modal-header>
                <div class="modal-body">
                    <s25-ng-email-template
                        [template]="data.template"
                        [eventReference]="data.reference"
                        (saved)="onSaved($event)"
                        (cancelled)="onCancelled()"
                    ></s25-ng-email-template>
                </div>
            </div>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ModalEditEmailTemplateComponent
    extends ModalComponent<{
        template: EmailTemplate | ToDoTemplate;
        reference?: string;
        onSave?: ((data: { id: number }) => unknown) | (() => unknown);
        onCancel?: () => unknown;
    }>
    implements OnInit
{
    isInit = false;

    ngOnInit() {
        this.isInit = true;
    }

    onSaved(data: { id: number }) {
        this.data.onSave?.(data);
        this.data.closeModal();
    }

    onCancelled() {
        this.data.closeModal();
    }
}
